// extracted by mini-css-extract-plugin
export var chatHtmlText = "_t3-2";
export var chatLink = "_t3-0";
export var chatText = "_t3-1";